import { Pipe, PipeTransform } from '@angular/core';
import { SlicePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'payStrSlice',
    standalone: false
})
export class StrSlicePipe implements PipeTransform {

    constructor(
        private slicePipe: SlicePipe,
        private translateService: TranslateService) {
    }

    transform(value: string, limit: number, start: number = 0, ellipsis: string = '...', separator: string = ''): string {
        if (!value) {
            return '';
        }

        return value.length <= limit ? value : this.slicePipe.transform(value, start, limit) + separator + this.translateService.instant(ellipsis);
    }
}
